<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-toolbar flat class="toolbar" dense justify="center">
        <v-toolbar-title align="center">
          <strong> Employee Leave Balance Report </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
          <v-radio
            label="Date Wise Report"
            value="datewise"
            color="#0f2027"
          ></v-radio>
          <v-radio
            label="Leave Balance Report"
            value="balance"
            color="#0f2027"
          ></v-radio>
        </v-radio-group>
      </v-row>
      <v-row dense justify="center">
        <v-col sm="2">
          <p><v-icon color="error">*</v-icon><b>Select Organization</b></p>
          <v-autocomplete
            rounded
            dense
            required
            v-model="org"
            :items="org_list"
            item-text="name"
            return-object
            label="Organization"
            outlined
            @change="getInstructors()"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="2" v-if="radios == 'datewise'">
          <p><v-icon color="error">*</v-icon><b>From Date</b></p>
          <!-- <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="selected_date"
                @blur="date = parseDate(selected_date)"
                v-on="on"
                prepend-icon="event"
                persistent-hint
                hint="YYYY-MM-DD FORMAT"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              no-title
              @input="menu1 = false"
              :max="nowDate"
            ></v-date-picker>
          </v-menu> -->

          <!-- new date code by shiv -->
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="selected_date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                persistent-hint
                hint="DD-MM-YYYY FORMAT"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @input="menu1 = false"
              :max="nowDate"
              ref="rv"
            ></v-date-picker>
          </v-menu>
          <!-- date code end -->
        </v-col>
        <v-col cols="12" sm="2" v-if="radios == 'datewise'">
          <p><v-icon color="error">*</v-icon><b>To Date</b></p>
          <!-- <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                dense
                v-model="to_date"
                @blur="todate = parseDate(to_date)"
                v-on="on"
                prepend-icon="event"
                persistent-hint
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="todate"
              no-title
              @input="menu2 = false"
            ></v-date-picker>
          </v-menu> -->
          <!-- new date code by shiv -->
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="to_date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                persistent-hint
                hint="DD-MM-YYYY FORMAT"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="todate"
              @input="menu2 = false"
              :max="nowDate"
              ref="rv"
            ></v-date-picker>
          </v-menu>
          <!-- date code end -->
        </v-col>
        <v-col
          cols="12"
          sm="2"
          v-if="radios == 'datewise' && instructor_list.length > 0"
        >
          <p><v-icon color="error">*</v-icon><b>Select Employee</b></p>

          <v-autocomplete
            clearable
            rounded
            outlined
            dense
            v-model="instructor"
            :items="instructor_list"
            item-text="name"
            item-value="id"
            label="Search Employee"
            persistent-hint
            single-line
          ></v-autocomplete>
        </v-col>
        <v-col sm="2" v-if="org && radios == 'datewise'">
          <p></p>
          <v-btn
            rounded
            class="button mt-6"
            @click="getAllReport()"
            :loading="fetch_loader"
            >Fetch</v-btn
          >
        </v-col>

        <v-col cols="12" sm="2" v-if="radios == 'balance'">
          <p><v-icon color="error">*</v-icon><b>Select Employee</b></p>

          <v-autocomplete
            clearable
            rounded
            outlined
            dense
            v-model="instructor"
            :items="instructor_list"
            item-text="name"
            item-value="id"
            label="Search Employee"
            persistent-hint
            single-line
          ></v-autocomplete>
        </v-col>
        <v-col sm="2" v-if="radios == 'balance'">
          <p></p>
          <v-btn
            rounded
            class="button mt-6"
            @click="getBalanceReport()"
            :loading="fetch_loader"
            >Fetch Balalce Report</v-btn
          >
        </v-col>
      </v-row>
      <!-- <v-row dense v-if="org_data_list!=''" justify="center">
                      <v-col sm="4" md="4">
                            <v-autocomplete clearable rounded outlined dense v-model="search" :items="org_data_list" item-text="emp_code" label="Search Employee" persistent-hint  single-line></v-autocomplete>
                      </v-col>
                 </v-row> -->
      <v-card
        class="box no-display"
        v-if="radios == 'datewise' && transactions_details.length > 0"
      >
        <!-- export btn code -->

        <v-col cols="12" sm="3" md="3" v-if="transactions_details != null">
          <v-btn color="success" dark class="exportbtn" outlined rounded @click="downloadTransactionReport">
            <!-- <download-excel
              class="mar"
              :data="transactions_details"
              :fields="table_fields"
              worksheet="DateWise_Report"
              name="DateWise_Report.xls"
            > -->
              <v-icon dark>mdi-file-excel</v-icon> Export
            <!-- </download-excel> -->
          </v-btn>
        </v-col>
        <!-- export btn code end-->

        <v-data-table :headers="headers" :items="transactions_details">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Employee Leave Data</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
      <v-card
        class="box no-display"
        v-if="radios == 'balance' && balacde_details.length > 0"
      >
        <!-- export btn code -->

        <v-col cols="12" sm="3" md="3" v-if="balacde_details != null">
          <v-btn color="success" dark class="exportbtn" outlined rounded @click="downloadBalanceReport">
            <!-- <download-excel
              class="mar"
              :data="balacde_details"
              :fields="table_fields1"
              worksheet="LeaveBalance_Report"
              name="LeaveBalance_Report.xls"
            > -->
              <v-icon dark>mdi-file-excel</v-icon> Export
            <!-- </download-excel> -->
          </v-btn>
        </v-col>
        <!-- export btn code end-->
        <v-data-table :headers="headers_balance" :items="balacde_details">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Employee Leave Balance Data</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
      <!-- <v-col cols="12" sm="12" md="12" v-if="org_data_list!=''">
            <v-simple-table dense class="elevation-1 mytable" fixed-header height="500px">
                    <thead>
                        <tr class="">
                            <th class="">Sr. No.</th>
                            <th class="">Employee</th>
                            <th class="">Mobile No.</th>
                            <th class="" colspan="5" v-for="(header,index) in leave_type_header" :key="index">
                                {{header}}
                            </th>
                        </tr>
                    </thead>
                    <tbody style="overflow-y: scroll;">
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <td v-for="(header,index) in leave_type_header.length * 5" :key="index">
                                <span v-if="header%5 == 0">
                                    Total Leaves
                                </span>
                                <span v-else-if="header%5 == 4">
                                    Remaining
                                </span>
                                <span v-else-if="header%5 == 3">
                                    Total Availed
                                </span>
                                 <span v-else-if="header%5 == 2">
                                    Approved
                                </span>
                                <span v-else>
                                    In Process
                                </span>
                            </td> 
                        </tr>
                        <tr v-for="(s,index) in todaylist" :key="s.std_id">
                            <td>{{index+1}}</td>
                            <td>{{s.emp_code}}</td>
                            <td>{{s.mobile_no}}</td>
                            <td v-for="(header,index) in s.leave_data" :key="index">
                                {{header}}
                            </td> 
                        </tr>
                    </tbody>
            </v-simple-table>
            </v-col> -->
    </v-card>
  </div>
</template>
<script>
import Header from "../../shared/UpdatedHeader.vue";
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import * as XLSX from "xlsx";
export default {
  components: { Header },
  data() {
    return {
      radios: null,
      loader: false,
      overlay: false,
      color: "",
      snackbar: false,
      search: null,
      snackbar_msg: null,
      header: null,
      org_list: null,
      display_data: false,
      org: "",
      ay: null,
      org_data_list: [],
      division_list: [],
      leave_type_header: [],
      dialog: false,
      org_data: [],
      fetch_loader: false,
      search: null,
      headers: [
        { text: "Sr No", value: "count" },
        { text: "Employee Code", value: "instructor_code" },
        { text: "Employee Name", value: "instructor" },
        { text: "Leave Type", value: "leavetype" },
        { text: "From Date", value: "fromdate" },
        { text: "To Date", value: "todate" },
        { text: "Days", value: "numberofdays" },
        { text: "Reason", value: "reason" },
        { text: "Approval Date", value: "approved_date" },
      ],
      table_fields: {
        "Sr. No": "count",
        Employee: "instructor",
        "Leave Type": "leavetype",
        "From Date": "fromdate",
        "To Date": "todate",
        Days: "numberofdays",
        Reason: "reason",
      },

      table_fields1: {
        Employee: "instructor",
        "Leave Type": "leavetype",
        "Leave Academic Year": "leaveacademicyear",
        "Total Leaves(Days)": "totalleaves",
        "Leaves In-Process(Days)": "leavesinprogress",
        "Total Avalied Leaves(Days)": "availedleaves",
        "Balance Leaves(Days)": "balanceleaves",
      },
      headers_balance: [
        {
          text: "Employee Code",
          align: "left",
          sortable: true,
          value: "instructor_code",
        },
        {
          text: "Employee Name",
          align: "left",
          sortable: true,
          value: "instructor",
        },
        {
          text: "Leave Type",
          align: "left",
          sortable: true,
          value: "leavetype",
        },
        {
          text: "Leave Academic Year",
          align: "left",
          sortable: false,
          value: "leaveacademicyear",
        } /*
        {
          text: 'Number Of Days',
          align: 'left',
          sortable: false,
          value: 'numberofdays',
        }, */,
        {
          text: "Total Leaves(Days)",
          align: "left",
          sortable: false,
          value: "totalleaves",
        },
        {
          text: "Leaves In-Process(Days)",
          align: "left",
          sortable: false,
          value: "leavesinprogress",
        },
        {
          text: "Total Avalied Leaves(Days)",
          align: "left",
          sortable: false,
          value: "availedleaves",
        },
        {
          text: "Balance Leaves(Days)",
          align: "left",
          sortable: false,
          value: "balanceleaves",
        },
      ],
      selected_date: "",
      to_date: "",
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      todate: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().slice(0, 10),
      instructor_list: [],
      instructor: "",
      transactions_details: [],
      balacde_details: [],
    };
  },
  computed: {
    todaylist() {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      if (!this.search) return this.org_data_list.sort(compare);
      return this.org_data_list.filter((tbdata) => {
        //  alert(tbdata.course_name)
        return (
          tbdata.emp_code.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      });
    },
  },
  methods: {
    getBalanceReport() {
      this.fetch_loader = true;
      const data = {
        org: this.org.id,
        instructor: this.instructor,
      };
      axios
        .post("/Management/getBalanceReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.balacde_details = res.data.leave_balance_report_list;
            this.fetch_loader = false;
          } else if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            this.fetch_loader = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.fetch_loader = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
          this.fetch_loader = false;
        })
        .finally(() => {
          //close loader
          this.fetch_loader = false;
        });
    },
    getInstructors() {
      this.fetch_loader = true;
      const data = {
        org: this.org.id,
      };
      axios
        .post("/Management/getInstructors", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fetch_loader = false;
            this.instructor_list = res.data.instructor_list;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.fetch_loader = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
          this.fetch_loader = false;
        })
        .finally(() => {
          //close loader
          this.fetch_loader = false;
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    clear() {
      this.org_data_list = [];
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/Management/getOrg_without_all")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.org_list = res.data.org_list;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
        })
        .finally(() => {
          //close loader
        });
    },
    getAllReport() {
      this.fetch_loader = true;
      const data = {
        org: this.org.id,
        fromdate: this.selected_date,
        todate: this.to_date,
        instructor: this.instructor,
      };
      axios
        .post("/Management/getEmployeeLeaveTransactionData", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.transactions_details = res.data.transactions_details;
            this.fetch_loader = false;
          } else if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            this.fetch_loader = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
            this.fetch_loader = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!");
          this.fetch_loader = false;
        })
        .finally(() => {
          //close loader
          this.fetch_loader = false;
        });
    },
    downloadTransactionReport() {
      this.loader = true;
      const excelData = this.transactions_details.map((item, index) => ({
        "S.No": index + 1,
        "Employee Code": item.instructor_code,
        "Employee Name": item.instructor,
        "Leave Type": item.leavetype,
        "From Date": item.fromdate,
        "To Date": item.todate,
        "Days": item.numberofdays,
        "Reason": item.reason, 
        "Approval Date": item.approved_date
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Leave Transaction Report");
      XLSX.writeFile(workbook, "leave_transaction_report.xlsx");

      this.loader = false;
    },
    downloadBalanceReport() {
      this.loader = true;
      const excelData = this.balacde_details.map((item, index) => ({
        "S.No": index + 1,
        "Employee Code": item.instructor_code,
        "Employee Name": item.instructor,
        "Leave Type": item.leavetype,
        "Leave Academic Year": item.leaveacademicyear,
        "Total Leaves(days)": item.numberofdays,
        "Leave In-process(days)": item.leavesinprogress,
        "Total Avalied Leaves(days)": item.availedleaves, 
        "Balance Leaves(days)": item.balanceleaves
      }));

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Leave Balane Report");
      XLSX.writeFile(workbook, "leave_balance_report.xlsx");

      this.loader = false;
    },
  },
  mounted() {
    this.onload();
    this.selected_date = this.formatDate(this.date);
    this.to_date = this.formatDate(this.todate);
  },
  watch: {
    date(val) {
      this.selected_date = this.formatDate(this.date);
    },
    todate(val) {
      this.to_date = this.formatDate(this.todate);
    },
  },
};
</script>
<style scoped>
.radiospace {
  margin: 1rem !important;
  padding: 0%;
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: center;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: center;
}
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
</style>
